export const nisService = {
  validate
}

function validate (nis) {
  if (nis.length === 0 && nis.length < 11) {
    return false
  }

  const multiplicador = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  let soma = 0
  let resto

  for (let i = 0; i < 10; i++) {
    soma += (parseInt(nis[i])) * multiplicador[i]
  }

  resto = soma % 11
  resto = 11 - resto

  if (resto === 10 || resto === 11) {
    resto = 0
  }

  if (resto === parseInt(nis[10])) {
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/services/validations/nisService.js